export enum BackgroundShape {
	SPHERE = "sphere",
	HELIX = "helix",
	GRID = "grid",
	// The card cloud tweens into the 奎 constellation — the name 旻奎 — tying the
	// classic view to the Star Sky theme's identity motif.
	CONSTELLATION = "constellation",
}
